import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SvgCom from '../../components/SvgCom/index.jsx';
import { ReactComponent as ArrowRightSvg } from '../../assets/svgs/arrow_right.svg';
import { getProjectList, getShowreelList } from '../../api/request.js';
import { useNavigate, useParams } from 'react-router-dom';

const SearchPage = () => {
  const type = useParams().type || 'all';
  const filter = useParams().filter || '';
  const [proNum, setProNum] = useState(0);
  const [showreelNum, setShowreelNum] = useState(0);
  const navigate = useNavigate();

  const getSearchList = useCallback(async () => {
    const params = {
      page: 1,
      page_size: 100,
      sort: '-created_at',
      search: filter
    };
    let resultList = [];
    const response = await getProjectList(params);
    if(response?.status === 200) {
      response?.data.forEach(item => {
        resultList.push({
          id: item.id,
          title: item.title,
          type: 'project'
        });
      });
      setProNum(response.data.length);
    }
    const responseShowreel = await getShowreelList(params);
    if(responseShowreel?.status === 'Success') {
      responseShowreel?.data.items.forEach((item) => {
        resultList.push({
          id: item.id,
          title: item.title,
          type: 'showreels'
        });
      });
      setShowreelNum(responseShowreel?.data.items.length);
    }
  }, [type, filter]);

  useEffect(() => {
    getSearchList();
  }, [getSearchList]);

  const resultNum = useMemo(() => {
    if(type === 'all') {
      return proNum + showreelNum;
    } else if(type === 'project') {
      return proNum;
    } else {
      return showreelNum;
    }
  }, [proNum, showreelNum, type]);

  return (
    <div className="px-[230px] py-[25px]">
      <div className="text-xl font-semibold text-grey-3 text-center mb-[40px]">
        <span className="text-primary">{resultNum}</span>
        <span> Results found with</span>
        {
          type === 'all' ? <></> :
            <span className="text-primary"> “{type} management” </span>
        }
        <span>in All</span>
      </div>

      {
        ['all', 'project'].includes(type) && <div onClick={() => navigate('/consumer-theatre-processing/project?filter=' + filter)} className="rounded-xl bg-grey-1 h-[130px] flex items-center mb-4 cursor-pointer">
          <div className="rounded-xl h-full w-[130px] bg-second flex justify-center items-center text-[40px] font-semibold text-primary">
            {proNum}
          </div>
          <div className="flex-1 px-[30px] flex items-center justify-between">
            <span className="text-2xl font-semibold text-primary leading-none">Project</span>
            <SvgCom Svg={ArrowRightSvg} size="40"></SvgCom>
          </div>
        </div>
      }
      {
        ['all', 'showreel'].includes(type) && <div onClick={() => navigate('/consumer-theatre-processing/showreel?filter=' + filter)} className="rounded-xl bg-grey-1 h-[130px] flex items-center mb-4 cursor-pointer">
          <div className="rounded-xl h-full w-[130px] bg-second flex justify-center items-center text-[40px] font-semibold text-primary">
            {showreelNum}
          </div>
          <div className="flex-1 px-[30px] flex items-center justify-between">
            <span className="text-2xl font-semibold text-primary leading-none">Showreels</span>
            <SvgCom Svg={ArrowRightSvg} size="40"></SvgCom>
          </div>
        </div>
      }
    </div>
  );
};

export default SearchPage;